/* eslint-disable */
import React, {useEffect} from 'react'
import { Layout, Breadcrumb, Radio } from 'antd'
import PageHeader from "components/PageHeader";
import MyFooter from "components/MyFooter";
import { history } from 'redux/store';
import { useTranslation } from 'react-i18next'

const { Header, Footer, Sider, Content } = Layout;


export default function AgreementTerm() {
  const { t } = useTranslation()
  const options = [
    { label: `${t('Footer.Terms')}`, value: '1' },
    { label: `${t('Footer.Policy')}`, value: '2' },
  ]
  const onChange = e => {
    console.log(e.target.value);
    if(e.target.value ==='1'){
      history.push('/Term')
    }else{
      history.push('/Privacy')
    }
  }
  return (
    <Layout>
    <Header>
      <PageHeader/>
    </Header>
    <Content style={{ height:'95vh' }}>

    <div className='innerlayout' style={{padding:'50px 5vw',width: '100%', margin:'auto', fontSize:'16px'}}>
        <Breadcrumb separator=">">
        <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
        <Breadcrumb.Item className='lastchild'>
          {t('FAQ.Legal')}
        </Breadcrumb.Item>
        </Breadcrumb>
      <div className='headtitle'>
      {t('FAQ.Legal')}
      </div>
      <div className='servicedetailradio' style={{marginBottom:'30px'}}>
            <Radio.Group 
              defaultValue="1"
              optionType="button"
              buttonStyle="solid"
              options={options}
              onChange={onChange} 
            />
      </div>
    <div className="agreelayoutPage" style={{width:'100%'}}>
    <div className='title'>
      {t('Footer.Terms')}
    </div>
    <div className="textEditor">
        <p>
            <span>緯謙科技股份有限公司（以下簡稱“<strong>本公司</strong>”）係根據本會員條款提供緯謙智慧雲市集服務（包含本公司的合作夥伴（以下簡稱“<strong>供應商</strong>”）提供的數位應用(以下簡稱“<strong>數位應用</strong>”)，以下合稱“<strong>本服務</strong>”）。當您代表所屬企業或法人組織（以下簡稱“<strong>用戶</strong>”）完成本服務之會員註冊/創建流程、訪問與使用本服務時，應受本條款的約束。</span>
        </p>
       
    <ol>
      <li style={{color:'#7DB926'}}><strong>條款的同意表示</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          <li>如果您代表用戶通過註冊程序成為本服務之會員，則您聲明並保證（i）您已閱讀並理解本條款；（ii）您有合法且完整的權限得代表用戶接受本條款約束。</li>
          <li>當您通過註冊或登入流程使用本服務時，即代表您已閱讀、瞭解並同意接受本條款的所有內容。如您不同意本條款之任何內容，請立即停止訪問與使用本服務。</li>
          <li>若您所在地區的法律不適用或排除本條款之所有或部分內容時，您應立即停止訪問與使用本服務。</li>
          <li>本公司有權在有必要時，得在不事先通知的情形下，隨時增修本條款，以規範對本服務之訪問與使用。變更後的條款自公布時起即時生效。如您不同意本條款變更後的任何內容，請立即停止訪問與使用本服務。</li>
          <li>在本條款公布變更後仍繼續訪問或使用本服務，即表示已接受並同意變更後的內容。本公司不會個別通知相關變更內容，故請您於每次訪問或使用本服務時，隨時參閱本條款最新版本的公布狀況。</li>
          <li>對供應商提供之數位應用的使用，同時受緯謙智慧雲市集服務協定與供應商之服務增補條款（以下合稱“<strong>服務協定</strong>”）的約束。如本條款與服務協定有所牴觸時，應以服務協定為準。</li>
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>使用授權與提供</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          <li>本服務與數位應用涉及的智慧財產權(包括但不限於著作權)，均屬於本公司及供應商所有。用戶與會員僅能於本條款及服務協定的許可範圍內，訪問或使用本服務，以及訂閱或使用供應商提供的數位應用。</li>
          <li>帳戶：用戶必須註冊/創建本服務之會員帳號才能訪問或使用本服務，並應對其為註冊/創建帳戶而提供的資料正確性、相關變更通知、帳號密碼的使用與安全性等負責。</li>
          <li>鏈結網站：通過本服務提供的URL連結可能允許離開本服務網站，鏈結到不受本服務控制的網站和網頁。本公司不以任何方式對鏈結網站（及其包含的任何網路連結、網頁或網址）負責，包括其相關內容以及安全性或隱私保護。</li>
          <li>無論是否通知用戶與會員，本公司有權自行決定新增、變更、刪除本服務的各項功能、服務內容與支援，或提供本服務的修復、增強功能、更新和升級。除本條款及服務協定另有規範外，本公司無義務提供任何數位應用之軟體更新或提供本服務後續版本。</li>
          <li>本公司為修復、維護、改善及升級任何基礎技術之目的，得不經通知用戶與會員，自行決定修改、終止或暫停使用本服務任何版本或本服務之任何功能。若供應商提供之數位應用在有效訂閱期間內因前述舉措產生重大不利影響，則本公司或供應商將會通知暫時停用或提前終止數位應用之訂閱或存取。</li>
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>服務停權與終止</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          <li>如果用戶或會員違反本條款或有違反之虞時，本公司得在不事先通知的情形下：（i）對會員帳號進行停權；（ii）終止本服務相關的使用授權；（iii）禁止訪問或使用本服務；（iiv）關閉並刪除會員帳號及所有相關資料及檔案。惟，會員帳號下尚未繳清的所有款項，並不因此免除或受影響。</li>
          <li>用戶與會員於訪問或使用本服務時不得從事下列所述行為，如有違反，本公司有權依照第3.1項辦理：

          ●	違反本條款之行為。<br/>
          ●	違反法令、法院判決、裁定或命令或具有法令約束力的行政措施行為。<br/>
          ●	恐有危害公共秩序或善良風俗的行為。<br/>
          ●	侵害本公司或第三人的著作權、商標權、專利權等智慧財產權、名譽權、隱私權、或其他法令或契約規定權利的行為。<br/>
          ●	干擾產品/服務的伺服器或網路系統的行為，利用BOT、作弊工具、其他技術性手段不當操作服務的行為、故意利用本服務或數位應用漏洞的行為、超出必要限度重複同一問題等對本公司提出不當洽詢或要求的行為、其他妨礙本公司經營本服務或其他用戶使用本服務或數位應用，並製造干擾的行為。<br/>
          ●	偽裝成本公司或第三人的行為或故意散佈不實或攻訐資訊的行為。<br/>
          ●	從本服務不當蒐集、公開或提供他人的個人資料、註冊資料、使用紀錄資料等的行為，亦不得嘗試存取用戶無權使用的資料。<br/>
          ●	其他本公司判斷為不適當的行為。<br/>

          </li>
    
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>權利與義務</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          <li>合規性：用戶應（i）確保用戶及其最終使用者對本服務的使用符合本條款，並且（ii）及時通知本公司任何未經授權訪問或使用本服務或數位應用的行為。</li>
          <li>	同意與接受服務協定：若有訂閱或使用數位應用，代表用戶已閱讀、瞭解並同意接受服務協定的所有內容。如有不同意服務協定之任何條款內容，請立即終止訂閱或使用任一數位應用。</li>
          <li>	供應商對會員數據的訪問：供應商提供的數位應用可能要求本服務從用戶與會員的資料中，提供相關資訊，以便提供供應商數位應用。通過訂閱或使用此類供應商數位應用，用戶與會員將授權本服務與此類數位應用的供應商共用資料，以便供應商提供其數位應用。此類資料的使用、儲存、刪除和處理將受本服務與供應商簽訂之供應商契約條款的約束。</li>
          <li>	限制：用戶與會員不得，也不會允許其最終使用者進行下列任何行為：
          <br/>●	規避或繞過設在軟體或本服務內或與軟體或本服務有關之任何技術保護措施；
          <br/>●	對本服務內含或可經由本服務而存取之任何軟體或服務之其他形式，進行反向組譯、解編、解密、破解、模擬、應用或還原工程，但若相關著作權法明示許可此類活動者，則不在此限。
          <br/>●	公佈、拷貝、出租、租賃、出售、出口、進口、散布或出借軟體或本服務（但該等作為業經本公司明示授權許可者，不在此限）；
          <br/>●	移轉軟體、軟體之任何授權或本服務之任何存取權或使用權；
          <br/>●	以任何可能干擾他人使用任何服務、資料、帳戶或網路之未經授權方式使用本服務；
          <br/>●	使未經授權之第三人得以訪問或使用本服務。
          <br/>●	未經本公司同意銷售或轉售本服務或供應商數位應用。
          </li>
          <li>	計費與付款：會員通過本服務訂閱/購買或使用數位應用時，應遵照訂閱/購買頁面上之計費與訂閱期間等使用條件，且完成付款程序後，方可取得數位應用之使用權。
          <br/>●	訂閱/購買/或使用數位應用：一旦會員收到本服務確認您訂閱/購買或使用數位應用的通知，且您完成付款程序後，即表示您的服務協定已同意且立即生效，但若您未於系統規定之時限內完成付款，付款時限屆滿後，該服務協定自動失效。
          <br/>●	金流付款處理方式：本服務提供多種金流付款處理方式，方便用戶與會員訂閱/購買或使用本服務提供的數位應用。您必須遵守您與本公司或第三方就您對特定金流付款處理方式所訂定的使用條款及細則或其他法律協議的規定。本公司可自行新增或移除金流付款處理方式，而不需事先通知。在您完成交易後，本公司或本公司委託的金流付款處理業者就會透過您的信用卡或您指定的其他付款方式收取訂閱/購買或使用數位應用的款項，並同時收取任何其他適用的費用 （包括任何稅款）。您必須為自己在本服務訂閱/購買或使用數位應用而產生的所有應付費用承擔全部責任。
          <br/>●	定價：不論是本公司自行銷售或協助供應商共同銷售之數位應用，本服務皆會將定價公布於本服務的訂閱/購買頁面上。完成訂閱/購買程序前，所有數位應用之定價皆可能隨時變更。若數位應用之定價有所調整，本服務會在定價調整生效至少前30天內發出通知提醒用戶或會員（若會員已訂閱/購賣的數位應用之訂閱期間尚未屆滿前，則不受數位應用定價變動之影響）。
          <br/>●	賦稅：用戶與會員有責任繳納任何「賦稅」，且針對數位應用付款時不得扣除任何「賦稅」。如果數位應用之賣方有義務收取或支付「賦稅」，則除非您提供相關稅務機關授予之有效免稅憑證，否則「賦稅」應由您負擔。「賦稅」係指與數位應用產品銷售相關且非所得稅的任何稅負、報關費用或賦稅，包括任何相關罰金或利息。
          <br/>●	遵守稅務法規：用戶與會員必須遵守一切任何適用稅務法規，您應負責申報並繳納任何這類適用賦稅。
          <br/>●	數位應用一經售出概不退換：本服務銷售之數位應用為軟體、應用程式、應用程式介面、解決方案，因此不適用7天猶豫期之規定，本服務提供之數位應用一經售出或訂閱/購買程序完成後，一概不得退還、更換或獲得退款。（除供應商之數位應用在其適用之訂閱期限到期之前終止提供，且用戶已在訂閱期內預付購買/使用訂閱該數位應用的款項，本公司將按比例向用戶與會員提供預付費用退款，以及供應商數位應用發生重大瑕疵影響用戶與會員持續使用之情形，則不在此限）。
          </li>
          <li>	起因於會員之停止使用或終止訂閱：會員可隨時停止使用本服務或終止訂閱任何供應商數位應用。在用戶與會員履行本條款項下的所有財物承諾（包括支付訂閱/購買或使用數位應用剩餘訂閱期限內的所有費用）的前提下，會員可以方便地終止使用本服務或終止訂閱/終止使用任一數位應用。終止後，用戶與會員必須在其訂閱期間屆滿後，停止使用該數位應用。</li>
          <li>	用戶與會員應自行承擔責任使用本服務與數位應用，對於在本服務與數位應用所從事的所有行為及其結果應自行負擔一切責任。</li>
          <li>	本公司認為用戶與會員在違反本條款情形下使用本服務與數位應用時，將採取本公司判斷有必要且適當的措施。但此不代表本公司有義務防止或糾正該等違反情形。</li>
          <li>	起因於用戶與會員使用本服務（包括本公司自第三人處收到原因為該等使用的申訴），致本公司直接或間接蒙受任何損害（包括律師費用的負擔）時，用戶與會員應依照本公司要求立即給予補償。</li>

        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>暫停提供訂閱、終止提供訂閱或終止提供供應商數位應用</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          <li>暫停提供訂閱：在以下情況下，供應商才能自行決定從本服務中暫停提供或禁止訂閱數位應用：（i）供應商為修復、維護、改善及升級數位應用的各項功能；（ii）供應商為調整數位應用的銷售地區，從本服務中暫時下架該數位應用，並待完成上述目的後，從本服務中恢復上架該數位應用。</li>
          <li>終止提供訂閱或終止提供：在以下情況下，本公司才能從本服務中移除訂閱或禁止訪問供應商數位應用：（i）本公司不再通過契約允許供應商在本服務上提供數位應用；（ii）本公司知悉或確定供應商數位應用（1）侵犯本公司或任何第三方的智慧財產權或任何其他權利；（2）違反任何適用法律或受制於禁令；（3）違反供應商契約或本公司不時更新的本條款；（4）可能會對本公司產生責任；（5）被本公司視為有病毒或惡意軟體、間諜軟體或其他惡意代碼；（6）影響本公司或用戶的網路或伺服器的完整性；或（7）不符合可接受的標準，包括基於功能與性能衡量標準；（8）在上述情況下，本公司會盡商業上合理的努力，在供應商之數位應用根據第5.2（i）（ii）條款被終止提供之前，提前發出通知予用戶或會員。</li>
       
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>智慧財產權</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          除本條款或服務協定中明確規定，否則本條款不授予任何一方對另一方的內容或任何其他智慧財產權的任何默示或其他權利。在三方之間，用戶與會員擁有用戶及會員數據中的所有智慧財產權；本公司擁有本服務中的所有智慧財產權；供應商擁有其所提供的數位應用中的所有智慧財產權。
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>本公司免責聲明</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          <li>不論明示或默示，本公司均未保證本服務（包括內容）不具有事實瑕疵（包括安全性、可靠性、正確性、完整性、有效性、特定目的的適用性、安全等相關缺陷、錯誤或程式錯誤、權利侵害等）。</li>
          <li>關於任何供應商數位應用的任何陳述或保證，由供應商承擔相應責任，包括（i）與任何供應商數位應用的性能、功能或安全性相關的任何陳述或保證；（ii）本服務中任何供應商數位應用清單的準確性或最新性。</li>
          <li>本公司明確表示不對供應商提供數位應用（包括任何相關技術支援），以及與供應商共用的與本條款或供應商數位應用相關的任何數據，承擔任何責任或義務。</li>
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>最終解釋權</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          本公司對本服務保有任何活動、限制等的最終解釋權。
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>商標</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          <li>本服務所指稱之「緯謙智慧雲市集」，「WiAdvance App Market」，以及所有供應商數位應用則依其註冊或使用之狀態，受商標法及公平交易法等之保護。</li>
          <li>本服務所指稱之所有其他非本公司所有之產品名、品牌名稱或公司名稱之財產權、商標權與註冊商標權歸屬各該權利歸屬公司所有。</li>
          <li>「緯謙智慧雲市集」，「WiAdvance App Market」，以及所有本公司之產品名稱或標誌，除獲得本公司事前之書面許可外，係被禁止使用於廣告或公眾相關之用途。</li>
        </ol>
      </li>
      <li style={{color:'#7DB926'}}><strong>準據法、管轄法院</strong>
        <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
          本條款之準據法為中華民國法律。起因於本條款或與本服務有關聯的爭議、主張及訴訟，您與本公司均同意以台灣台北地方法院為第一審管轄法院。用戶並同意除法令另有規定外，因本條款或本服務之使用而引發之一切爭議，本公司僅需就故意或重大過失行為負責任
        </ol>
      </li>
      本條款最新版本日期為2022年6月。
    </ol>
    </div>
    </div>
    </div>
    <MyFooter />
    </Content>

    </Layout>
  )
}
